import React, { useState } from 'react';

export default function SaveConfigModal({ onClose, onSave, existingNames }) {
  const [configName, setConfigName] = useState('');
  const [showOverwriteConfirm, setShowOverwriteConfirm] = useState(false);

  const handleSave = () => {
    const trimmedName = configName.trim();
    if (!trimmedName) return;

    // Check if name exists
    if (existingNames.includes(trimmedName)) {
      setShowOverwriteConfirm(true);
    } else {
      onSave(trimmedName);
      onClose();
    }
  };

  const handleOverwrite = () => {
    onSave(configName.trim());
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  if (showOverwriteConfirm) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
          <h2>Name Exists</h2>
          <p style={{ marginBottom: '20px' }}>
            A configuration named "<strong>{configName.trim()}</strong>" already exists. Overwrite it?
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button onClick={onClose} className="btn">
              Cancel
            </button>
            <button 
              onClick={handleOverwrite} 
              className="btn"
              style={{ background: '#dc3545' }}
            >
              Overwrite
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Save Configuration</h2>
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Configuration Name:
          </label>
          <input
            type="text"
            value={configName}
            onChange={(e) => setConfigName(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="e.g., Aggressive 7s"
            autoFocus
            style={{
              width: '100%',
              padding: '8px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              boxSizing: 'border-box'
            }}
          />
        </div>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} className="btn">
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            className="btn"
            disabled={!configName.trim()}
            style={{
              opacity: configName.trim() ? 1 : 0.5,
              cursor: configName.trim() ? 'pointer' : 'not-allowed'
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
